import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// Posts a vault upload; if the same file already exists, asks before uploading a second copy.
export async function uploadToVault({ formData, json, headers }) {
  const url = json ? `${API}/api/document-vault/upload-from-url` : `${API}/api/document-vault/upload`;
  const send = (force) => {
    if (json) return axios.post(url, { ...json, force }, { headers });
    if (force) formData.set('force', 'true');
    return axios.post(url, formData, { headers });
  };
  try {
    return (await send(false)).data;
  } catch (e) {
    const d = e?.response?.data?.detail;
    if (e?.response?.status === 409 && d?.error === 'duplicate') {
      if (!window.confirm(`${d.message}\n\nUpload a second copy anyway?`)) return null;
      return (await send(true)).data;
    }
    throw e;
  }
}

export function apiErrorText(e, fallback = 'Upload failed') {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (d?.message) return d.message;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(' ');
  return fallback;
}

// Members-only files need the login token, so fetch as a blob instead of a plain link.
export async function openVaultFile(storagePath) {
  const win = window.open('', '_blank');
  try {
    const r = await axios.get(`${API}/api/document-vault/file/${String(storagePath).replace(/^\/+/, '')}`, { responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    if (win) win.location.href = url; else window.open(url, '_blank');
  } catch (e) {
    if (win) win.close();
    throw e;
  }
}
